import { render, staticRenderFns } from "./BlockRule.vue?vue&type=template&id=160ec2f1&scoped=true"
import script from "./BlockRule.vue?vue&type=script&lang=js"
export * from "./BlockRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160ec2f1",
  null
  
)

export default component.exports